export default [
  {
    no: '1',
    path: 'microbeads',
    name: 'マイクロプラスチックビーズ',
    reading: 'マイクロプラスチックビーズ',
    whatAreThey:
      '一般的に、水に溶けない5mm以下のプラスチック粒子をマイクロプラスチックといいます。このうち洗浄や角質除去のために洗い流すタイプの製品に使用されるものをマイクロプラスチックビーズと呼びます。',
    whereFrom: '異なる大きさや形で生成された合成プラスチック粒子です。',
    risks:
      'マイクロプラスチックビーズは材質や形状などにより、水生生物や食物連鎖による人体への影響が懸念されるため、現在世界各国でその研究が進められています。現時点ではマイクロプラスチックビーズは回収することが困難であるため、環境中に存在し続けることが分かっています。\n2015年12月、米国では化粧品中のマイクロプラスチックビーズを禁止する規制が施行され、それを受け多くの国で洗い流すタイプの化粧品へのマイクロプラスチックビーズの配合が禁止されました。\nただし、化粧品に含まれるマイクロプラスチックビーズ量は、海洋環境中のプラスチック汚染総量の2%未満であり、長期的な環境負荷は現在調査中です。',
    whyAndHow:
      '私たちは、2018年以来、洗い流すタイプの製品へマイクロプラスチックビーズは使用していません。さらに私たちは、マイクロプラスチックの研究や規制の進捗を注視し、迅速な対応が行えるように準備を進めています。',
    related: ['6', '4', '16'],
    metaTitle: 'マイクロプラスチックビーズ',
    metaKeywords: 'マイクロプラスチックビーズ',
    metaDescription:
      '資生堂は、2018年以来、洗い流すタイプの化粧品へマイクロプラスチックビーズは使用していません。さらに私たちは、マイクロプラスチックの研究や規制の進捗を注視し、迅速な対応が行えるように準備を進めています。',
  },
  {
    no: '2',
    path: 'oxybenzone',
    name: 'オキシベンゾン-3',
    reading: 'オキシベンゾン-3',
    whatAreThey:
      'ベンゾフェノン類として知られる化学物質に属する合成化合物で、家庭用品や、サングラス、食品包装などで広く使用されています。\n化粧品では、紫外線を吸収し、肌を保護し、中味の変質を防ぐ目的で使用されています。',
    whereFrom:
      'さまざまな植物に含まれている天然の化学物質ですが、化粧品には合成されたものが使用されています。',
    risks:
      'オキシベンゾン-3は、WHOでは成長や免疫機能に影響を与える内分泌かく乱物質ではないと定義されています。しかし欧州では内分泌かく乱物質の懸念がある成分として安全性調査が継続されています。\nまた、海洋中でのサンゴへの影響について研究者の間で議論されており、日焼け止めが主目的のオキシベンゾン-3を含む製品については2018年7月ハワイ州では販売が禁止され、パラオやタイ国立公園においては、レジャー用途での使用が禁止されました。',
    whyAndHow:
      '私たちは、各国の規制動向と、資生堂独自の安全基準に準じ、オキシベンゾン-3を使用しない製品の開発・改良を進めています。',
    related: ['6', '4', '16'],
    metaTitle: 'オキシベンゾン-3',
    metaKeywords: 'オキシベンゾン',
    metaDescription:
      '資生堂は、各国の規制動向と、独自の安全基準に準じ、オキシベンゾン-3を使用しない化粧品の開発・改良を進めています。',
  },
  {
    no: '3',
    path: 'octocrylene',
    name: 'オクトクリレン',
    reading: 'オクトクリレン',
    whatAreThey:
      '紫外線の有害な影響から肌を防御するために、日焼け止め化粧品で使用される合成化合物です。',
    whereFrom: '化学的に合成された成分です。',
    risks:
      'オクトクリレンは、WHOでは成長や免疫機能に影響を与える内分泌かく乱物質ではないと定義しています。また欧州でも長らく検討されてきましたが、この度（2021年）UV配合が認められている濃度の範囲で内分泌かく乱物質作用がないことが結論付けられました。\nまた、海洋中でのサンゴへの影響について研究者の間で議論されており、21年時点ではハワイでの使用は許可されていますが、パラオや米国のヴァージン諸島ではレジャー用途での使用が禁止されています。',
    whyAndHow:
      '私たちは、資生堂独自の安全基準と、各国の法規制に準じ、オクトクリレンを使用しています。\nまた、造礁サンゴ類やサンゴ礁生物にまつわる研究テーマに取り組んでいる大学研究室との共同研究と高度な海洋中濃度シミュレーションを組み合わせる事でサンゴへの影響を精査に予測しています。海で使用するレジャー用サンスクリーンに使用する場合にはサンゴへの影響に配慮した処方設計を行っています。\nオクトクリレンについて、各国の規制動向や環境影響調査結果を注視して適切に対応していきます。',
    related: ['6', '4', '16'],
    metaTitle: 'オクトクリレン',
    metaKeywords: 'オクトクリレン',
    metaDescription:
      '資生堂は、独自の安全基準と、各国の法規制に準じるだけではなく、環境影響調査も行いながら、オクトクリレンを使用しています。',
  },
  {
    no: '4',
    path: 'cyclosiloxanes',
    name: '環状シリコーン',
    reading: 'カンジョウシリコーン',
    whatAreThey:
      'シリコーンには多くの種類があります。環状シリコーンと呼ばれるシクロテトラシロキサン(D4),シクロペンタシロキサン(D5),シクロヘキサシロキサン(D6)は、代表的なシリコーンで、環状の化学構造と様々な特性から、なめらかで軽やかな感触を実現する揮発性の油です。',
    whereFrom: '珪石から化学的に合成されます。',
    risks:
      'D4、D5、D6は環境内で分解されませんが、長期的な影響はまだ明らかになっていません。D4およびD5は、欧州では洗い流すタイプの化粧品では濃度0.1％以上での使用は許可されていません。D6 は現在審査中です。\nD4は、欧州で生殖毒性が疑われている化学物質リストに登録されています。',
    whyAndHow:
      '私たちは、環境への配慮から、シャンプーやコンディショナーなどの洗い流すタイプの製品には、環状シリコーンを使用していません。\nまた、D4は生殖毒性作用があると疑われているため、使用を停止しました。\nD5とD6は洗い流さないタイプの製品には使用していますが、法規制動向を注視し、適切な対応を進めていきます。',
    related: ['6', '4', '16'],
    metaTitle: '環状シリコーン',
    metaKeywords: '環状シリコーン,D4,D5,D6',
    metaDescription:
      '資生堂は、環境への配慮から、シャンプーやコンディショナーなどの洗い流すタイプの化粧品には、環状シリコーンを使用していません。',
  },
  {
    no: '5',
    path: 'silicones',
    name: 'シリコーン',
    reading: 'シリコーン',
    whatAreThey:
      '様々な化学構造で、なめらかな感触をもたらし、保湿剤、粘度調整、ヘアコンディショニングなどの幅広い用途を持つ不活性合成ポリマーです。',
    whereFrom: '珪石から化学的に合成されます。',
    risks:
      'シリコーンは、頭皮や肌の毛穴の詰まりや乾燥、うっ血を引き起こすことが疑われています。また、シリコーンは簡単に生分解されないため、環境中に残存することが懸念されています。しかしながら、シリコーンを含む化粧品が、頭皮や肌および環境に悪影響を与えるという科学的証拠はありません。',
    whyAndHow:
      '私たちは、環境負荷を最小限に抑えつつ、高品質のシリコーンを使用しています。',
    related: ['6', '4', '16'],
    metaTitle: 'シリコーン',
    metaKeywords: 'シリコーン',
    metaDescription:
      'シリコーンは簡単に生分解されないため、環境中に残存することが懸念されていますが、シリコーンを含む化粧品が、頭皮や肌および環境に悪影響を与えるという科学的証拠はありません。資生堂は、環境負荷を最小限に抑えつつ、高品質のシリコーンを使用しています。',
  },
  {
    no: '6',
    path: 'parabens',
    name: 'パラベン',
    reading: 'パラベン',
    whatAreThey:
      '食品、医薬品、化粧品などで使用される防腐剤です。微生物汚染を防ぎ、製品の安全性と品質を守るために使用されています。',
    whereFrom:
      '赤い果実、ニンジン、ローヤルゼリーに自然に含まれていますが、化粧品には合成されたものが使用されています。',
    risks:
      'パラベンは、内分泌かく乱物質であると疑われていますが、その活性は、パラベンの分子構造の長さとともに増加します。より長い構造を有するパラベン（例：ブチルパラベンやプロピルパラベン）はより強い活性を有していますが、短い構造を有するパラベン（エチルパラベンとメチルパラベン）は非常に低い活性を有し、より安全であると考えられます。欧州では、化粧品へのパラベン類の使用に制限を設けて、その限りにおいては安全性を保証できるとしています。\nさらにはがんを誘発する疑いがありますが、すべてのパラベンにおいて、化粧品の法規制内の使用によるがんの増加は報告されていません。',
    whyAndHow:
      '私たちは、資生堂独自の安全基準に準じ、多くの製品において、規制機関が設定した濃度よりも低い濃度の範囲でエチルパラベンとメチルパラベンを使用しています。\nまた、私たちはブチルパラベンとプロピルパラベンを含まない製品の開発・改良を進めています。',
    related: ['6', '4', '16'],
    metaTitle: 'パラベン',
    metaKeywords: 'パラベン',
    metaDescription:
      '資生堂は、独自の安全基準に準じ、規制機関が設定した濃度よりも低い濃度の範囲でエチルパラベンとメチルパラベンを使用しています。短い構造を有するパラベン（エチルパラベンとメチルパラベン）の内分泌かく乱の活性は非常に低く、より安全であると考えられます。また、私たちはブチルパラベンとプロピルパラベンを含まない化粧品の開発・改良を進めています。',
  },
  {
    no: '7',
    path: 'mit-mci',
    name: 'メチルイソチアゾリノン／メチルクロロイソチアゾリノン',
    subtitle: 'MIT/MCI',
    breadcrumbTitle: 'MIT/MCI',
    reading: 'メチルイソチアゾリノン／メチルクロロイソチアゾリノン',
    whatAreThey:
      'メチルイソチアゾリノン（MIT）とメチルクロロイソチアゾリノン（MCI）は、化学的に似ている防腐剤で、多くのパーソナルケア製品に混合物で使用されています。水溶液中における微生物の増殖を制御することで、変色、不快な臭い、中味の劣化を防ぎます。',
    whereFrom: '化学的に合成された成分です。',
    risks:
      'MITとMCIは、アレルギー反応や湿疹の原因となる疑いがあります。MIT単独のアレルギーのリスクは、洗い流さないタイプの製品で確認され、欧州では2017年2月に洗い流さないタイプの製品でのMIT単独の使用を禁止しました。\nMCIの規制によって許可された濃度の範囲での使用は安全とみなされています。',
    whyAndHow:
      '私たちは、資生堂独自の安全基準に準じ、MIT/MCIを使用していません。',
    related: ['6', '4', '16'],
    metaTitle: 'メチルイソチアゾリノン/メチルクロロイソチアゾリノン',
    metaKeywords: 'メチルイソチアゾリノン,メチルクロロイソチアゾリノン,MIT,MCI',
    metaDescription:
      '資生堂は、独自の安全基準に準じ、新製品にMIT/MCIを使用していません。MIT単独では、全ての製品で使用していません。',
  },
  {
    no: '8',
    path: 'phenoxyethanol',
    name: 'フェノキシエタノール',
    reading: 'フェノキシエタノール',
    whatAreThey:
      '水を含む製品に一般的に使用される防腐剤で、真菌、細菌、酵母の増殖を抑制する特性があります。',
    whereFrom:
      '緑茶に含まれていますが、化粧品には合成されたものが使用されています。',
    risks:
      'いくつかの研究では、特に赤ちゃんのおむつに使用した場合に、肌への刺激とアレルギーを起こすことが示されており、日本の化粧品基準では、安全な最大濃度制限を1％に設定しています。\nフェノキシエタノールは、内分泌かく乱物質や肝臓に悪影響を及ぼす成分であるという疑いがもたれていますが、内分泌かく乱研究機関であるThe  Endocrine Disruption Exchangeによれば、内分泌かく乱物質とは考えられておりません。',
    whyAndHow:
      '私たちは、資生堂独自の安全基準と、日本を含む各国の規制に準じ、ほとんどの製品において最大濃度制限を大幅に下回る濃度でフェノキシエタノールを使用しています。',
    related: ['6', '4', '16'],
    metaTitle: 'フェノキシエタノール',
    metaKeywords: 'フェノキシエタノール',
    metaDescription:
      '資生堂は、独自の安全基準と、日本を含む各国の規制に準じ、ほとんどの製品において許容濃度を大幅に下回る濃度でフェノキシエタノールを使用しています。',
  },
  {
    no: '9',
    path: 'bht',
    name: 'BHT（ジブチルヒドロキシトルエン）',
    reading: 'ジブチルヒドロキシトルエン',
    breadcrumbTitle: 'BHT',
    whatAreThey:
      '多くのパーソナルケア製品や食品の保存のために使用される安定化剤です。油脂やビタミンなどの有効成分の安定性を維持する抗酸化剤です。',
    whereFrom:
      'ライチ果実にも含まれていますが、製品には合成されたものが使用されています。',
    risks:
      'いくつかの研究は、BHTが内分泌かく乱物質である可能性を示唆していることから、欧州では、より多くの科学的なデータで評価するために、内分泌かく乱物質の評価優先リストにBHTを含め、検証中です。現在、欧州の規制では、全ての化粧品における配合が許可されています。',
    whyAndHow:
      '私たちは、資生堂独自の安全基準と、日本を含む各国の規制に準じ、洗い流すタイプと洗い流さないタイプの両方の製品で、0.1%以下の濃度で使用しています。',
    related: ['6', '4', '16'],
    metaTitle: 'BHT（ジブチルヒドロキシトルエン）',
    metaKeywords: 'BHT,ジブチルヒドロキシトルエン',
    metaDescription:
      '資生堂は、独自の安全基準と、日本を含む各国の規制に準じ、洗い流すタイプと洗い流さないタイプの両方の化粧品で、0.1%以下の濃度で使用しています。',
  },
  {
    no: '10',
    path: 'bha',
    name: 'BHA（ブチルヒドロキシアニソール）',
    reading: 'ブチルヒドロキシアニソール',
    breadcrumbTitle: 'BHA',
    whatAreThey:
      '多くのパーソナルケア製品や食品の保存のために使用される安定化剤です。油脂やビタミンなどの有効成分の安定性を維持する抗酸化剤です。',
    whereFrom: '化学的に合成された成分です。',
    risks:
      'BHAは、生殖機能障害、発がんリスクの増加(乳房および前立腺を含む)、および他の慢性的または不可逆的な健康上の問題に関連していると言われています。\n欧州では、より多くの科学的なデータで評価するために、内分泌かく乱物質の評価優先リストにBHAを含め、検証中です。\nBHAは、カリフォルニア州のProposition 65では既知の発がん性物質としてリストに記載されています。',
    whyAndHow: '私たちは、資生堂独自の安全基準に従い、BHAを使用していません。',
    related: ['6', '4', '16'],
    metaTitle: 'BHA（ブチルヒドロキシアニソール）',
    metaKeywords: 'ブチルヒドロキシアニソール,BHA',
    metaDescription: '資生堂は、独自の安全基準に従い、BHAを使用していません。',
  },
  {
    no: '11',
    path: 'triclosan',
    name: 'トリクロサン',
    reading: 'トリクロサン',
    whatAreThey:
      '抗菌作用があるとして1957年以来広く使用されている防腐剤です。 パーソナルケア製品や、衣類、カーペット、プラスチック、おもちゃなど多くの種類の製品に使用されています。',
    whereFrom: '化学的に合成された成分です。',
    risks:
      'トリクロサンは内分泌かく乱作用が懸念され、甲状腺機能や甲状腺恒常性に影響を与えると言われています。\nトリクロサンの使用が抗生物質に耐性のある細菌の増加に寄与しているという報告もあります。\n米国食品医薬品局が2016年9月に、優れた殺菌効果があるとは言えないことを理由に、本成分配合の抗菌石鹸の発売を禁止しました。',
    whyAndHow:
      '私たちは、資生堂独自の安全基準に従い、トリクロサンを使用していません。',
    related: ['6', '4', '16'],
    metaTitle: 'トリクロサン',
    metaKeywords: 'トリクロサン',
    metaDescription:
      '資生堂は、独自の安全基準に従い、トリクロサンを使用していません。',
  },
  {
    no: '12',
    path: 'nano-particles',
    name: 'ナノ粒子',
    reading: 'ナノ粒子',
    subtitle: '酸化亜鉛、二酸化チタン',
    whatAreThey:
      '1~100ナノメートルの大きさの粒子で、肉眼や一般的な顕微鏡では見えないくらい非常に小さなものです。\n化粧品で使用されるナノ粒子としては日焼け止め製品に使用されている酸化亜鉛や二酸化チタンが知られていますが、可視光をあまり反射しないため、肌に塗布しても白くならない特徴があります。',
    whereFrom:
      '自然界にそのまま存在するものと、化学的に合成されるものがあります。',
    risks:
      'ナノ粒子が肌に浸透し、最終的に内臓または血流に入る可能性があること、またそれらが有毒になる可能性があることが一般的に懸念されていますが、欧州では、ナノ粒子が健康な肌には浸透しないことを明らかにしたことから、安全であると考えられています。しかしながら、粉末又はエアゾール製品から吸入された粒子の安全性はまだ検証されていません。\nナノ粒子は世界中で使用許可されており、欧州など一部の国では、物質名の後に括弧内に「ナノ」という単語を付けて成分リストにラベルを付ける必要があります。',
    whyAndHow:
      '私たちは、その高い機能性からナノサイズの二酸化チタンや酸化亜鉛を日焼け止め製品に使用しています。これらの成分は私たちも肌に浸透しないと評価し、安全と考えています。また、一般的に乳液や化粧水など水分を含む製品に配合されているため、ナノ粒子を吸入するリスクは低くなります。私たちは、さらに、万が一吸入される可能性のある量についても、人体への健康リスクはないことを確認しています。',
    related: ['6', '4', '16'],
    metaTitle: 'ナノ粒子 (酸化亜鉛、二酸化チタン) ',
    metaKeywords: 'ナノ粒子,酸化亜鉛,二酸化チタン,ZnO,TiO2',
    metaDescription:
      '資生堂は、その高い機能性からナノサイズの二酸化チタンや酸化亜鉛を日焼け止め製品に使用しています。これらの成分は肌に浸透しないと評価し、安全と考えています。また、万が一吸入される可能性のある量についても、人体への健康リスクはないことを確認しています。',
  },
  {
    no: '13',
    path: 'sulfates',
    name: 'アルキル硫酸塩',
    reading: 'アルキル硫酸塩',
    subtitle:
      'ラウリル硫酸ナトリウム、ラウレス硫酸ナトリウム、ラウリル硫酸アンモニウム',
    whatAreThey:
      'アルキル硫酸塩は、洗剤や界面活性剤の一種として、泡立ちに優れています。また、水が油や汚れと混ざり合い、洗い流せるようにすることで、肌や髪を清潔に保つことができます。',
    whereFrom: 'パーム核油またはココナッツ油から化学的につくられます。',
    risks:
      'アルキル硫酸塩は肌への刺激、乾燥、発がん性が懸念されていますが、WHO、IARC、欧州などの当局からの発がん性物質のリストには含まれてなく、発がん性に関する明確な科学的証拠はありません。\n化粧品において、軽度の肌への刺激が数例報告されていますが、石鹸のように洗い流すタイプの化粧品で使用した場合の安全性は確認されています。',
    whyAndHow:
      '私たちは、頭皮や肌への刺激を起こさないよう使用量を最小限にして、主に洗い流すタイプの製品でアルキル硫酸塩を使用しています。また、原料の品質や効果を保持するために微量に使用する場合もあります。',
    related: ['6', '4', '16'],
    metaTitle: 'アルキル硫酸塩',
    metaKeywords:
      'アルキル硫酸塩,ラウリル硫酸ナトリウム,ラウレス硫酸ナトリウム,ラウリル硫酸アンモニウム,SLS,SLES,ALS',
    metaDescription:
      '資生堂は、頭皮や肌への刺激を起こさないよう使用量を最小限にして、洗い流すヘアケアやボディウォッシュ製品での使用に限定し、アルキル硫酸塩を使用しています。ただし、原料の品質保持のために微量に含まれる製品を除きます',
  },
  {
    no: '14',
    path: 'petrolatum',
    name: 'ワセリン',
    reading: 'ワセリン',
    whatAreThey:
      '1859年から保湿剤として使用されている無臭、無色のゼリー状の物質です。',
    whereFrom: '石油から精製されます。',
    risks:
      'ワセリンには、発がん性のある多環芳香族炭化水素(PAHs)などの不純物が含まれていることが懸念されていますが、高度に精製されたワセリン(医薬品および化粧品グレード)には、PAHsが含まれないため安全であると世界的に考えられています。軽度の肌への刺激を治療するための皮膚科薬として多用されているほどです。',
    whyAndHow:
      '私たちは、資生堂独自の安全基準に準じ、人体に有害な不純物を含まない高純度のワセリン（医薬品にも一部使用可能）を使用しています。',
    related: ['6', '4', '16'],
    metaTitle: 'ワセリン',
    metaKeywords: 'ワセリン',
    metaDescription:
      '資生堂は、独自の安全基準に準じ、人体に有害な不純物を含まない高純度の化粧品/医薬品グレードのワセリンを使用しています。',
  },
  {
    no: '15',
    path: 'palm-oil',
    name: 'パーム油',
    reading: 'パーム油',
    whatAreThey:
      '無臭、無色の食用植物油です。グリセリンや脂肪酸等、様々な用途で化粧品にも使用されています。（グリセリンは保湿効果をもつエモリエント剤です。）',
    whereFrom:
      'アブラヤシの木から得られる2種類の油が原料です。一つはパームの果肉から得られるパーム油、もう一つは、種子から得られるパーム核油です。',
    risks:
      '無計画なパーム油の生産は、生物多様性の宝庫であるインドネシアとマレーシアの森林破壊を引き起こし、また、炭素が豊富な泥炭地を野焼きすることで、温室効果ガスが大気中に放出され、気候変動の一因となっています。一部のパーム油プランテーションでは、労働者の権利の侵害や、児童労働の可能性も指摘されています。\n持続可能なパーム油の生産のため、2004年に設立されたRSPO（Roundtable of Sustainable Palm Oil、持続可能なパーム油のための円卓会議)では、環境および社会の原則に基づいて持続可能なパーム油の普及を推進しています。RSPO認証されたパーム油は、野焼きされた土地では育っていない、持続可能な生産が行われていること、小規模農家の労働条件も公正であることが保証されます。',
    whyAndHow:
      '私たちは、2010年にRSPOに加入して以来、認証された持続可能なパーム油の生産を支持してきました。使用する全パーム由来原料について目標を宣言し、持続可能な調達に努めています。',
    related: ['6', '4', '16'],
    metaTitle: 'パーム油',
    metaKeywords: 'パーム油',
    metaDescription:
      '資生堂は、2010年にRSPOに加入して以来、認証された持続可能なパーム油の生産を支持してきました。使用する全パーム由来原料油について目標を宣言し、持続可能な調達に努めています。',
  },
  {
    no: '16',
    path: 'mica',
    name: 'マイカ',
    reading: 'マイカ',
    whatAreThey:
      '白い輝きやツヤを与えるために、メイクアップ製品に使用される天然ミネラル成分です。',
    whereFrom:
      '有史時代前から使用されてきた様々な種類の岩石に存在するケイ酸塩鉱物のグループです。\nまた、化学的に合成することもできます。',
    risks:
      'インドのマイカは主に社会的、経済的に問題を抱える地域由来のものが多く、児童労働や違法労働のリスクがあります。サプライチェーンが複雑なため、完全な評価が困難な状況です。\n2017年1月に設立された非政府組織で、責任ある調達を推進するResponsible Mica Initiativeは、児童労働と劣悪な労働条件を根絶することにより、インドで持続可能なマイカサプライチェーンを構築しています。\nマイカは天然鉱石由来のため、微量の重金属が含まれている可能性があります。',
    whyAndHow:
      '私たちは、Responsible Mica Initiativeに参加し、持続可能な調達に向けた改善に取り組んでいます。\n私たちが使用するマイカは重金属含有量が安全な範囲内であることを確認しています。また、私たちは、より重金属量が少なく社会的懸念の少ない合成マイカも使用しています。',
    related: ['6', '4', '16'],
    metaTitle: 'マイカ',
    metaKeywords: 'マイカ',
    metaDescription:
      '資生堂は、Responsible Mica Initiativeに参加し、持続可能な調達に向けた改善に取り組んでいます。私たちが使用するマイカは重金属含有量が安全な範囲内であることを確認しています。',
  },
  {
    no: '17',
    path: 'essential-oils',
    name: '精油',
    reading: 'セイユ',
    whatAreThey:
      '精油は、自然由来の特徴的な香りを持つオイルで、植物から抽出されます。',
    whereFrom: '精油は、植物の様々な部分から抽出されます。',
    risks:
      '精油には、肌アレルギーを引き起こす可能性のあるアレルゲンが含まれることがあります。国際フレグランス協会は、接触アレルギーを最小限に抑えるために、精油の推奨濃度上限を設定しています。 さらに、欧州では、製品にアレルギー性の高い26個の物質のいずれかが含まれている場合、製品ラベルに表示することを義務付けています。一般的に化粧品においては、推奨用量の範囲であれば、精油を含む製品に対するアレルギー反応はほとんどありません。',
    whyAndHow:
      '私たちは、資生堂独自の安全基準に準じ、精油の濃度を国際フレグランス協会および各国の法規制の中で最も低いレベルに制限して、アレルギーのリスクを最小限に抑えた上で、使用しています。\n欧州などで販売されている製品の成分リストにはアレルゲンの名前を示しています。',
    related: ['6', '4', '16'],
    metaTitle: '精油',
    metaKeywords: '精油,エッセンシャルオイル',
    metaDescription:
      '資生堂は、独自の安全基準に準じ、精油の濃度を国際フレグランス協会および各国の法規制の中で最も低いレベルに制限して、アレルギーのリスクを最小限に抑えた上で、使用しています。',
  },
  {
    no: '18',
    path: 'synthetic-fragrances',
    name: '合成香料',
    reading: 'ゴウセイコウリョウ',
    whatAreThey:
      '合成香料は、より手頃な価格で、また効率的な方法で自然の香りを再現したり、独特の香りを提供するために使用されます。',
    whereFrom:
      '所望の香りを生み出すために化学的に合成された成分であり、アルコール、安定剤、UV吸収剤、防腐剤、染料などの混合物です。',
    risks:
      '香料の成分組成が開示されていないため、ラベルの「香料」という記載から、安全性の問題に関連する合成化学物質が含まれている可能性が懸念されることがあります。国際フレグランス協会は、人体への安全性リスクを最小化するために、香料成分の推奨濃度上限を設定しています。\nさらに、欧州では、製品にアレルギー性の高い26個の物質のいずれかが含まれている場合、ラベルに表示することを義務付けています。一般的に化粧品においては、推奨用量の範囲であれば、合成香料を含む製品が原因で生じるアレルギー反応はほとんどありません。 ',
    whyAndHow:
      '私たちは、資生堂独自の安全基準に準じ、合成香料の濃度を国際フレグランス協会および各国の法規制の中で最も低いレベルに制限して、アレルギーのリスクを最小限に抑えた上で、使用しています。\n欧州などで販売されている製品の成分リストにはアレルゲンの名前を示しています。',
    related: ['6', '4', '16'],
    metaTitle: '合成香料',
    metaKeywords: '合成香料,香料',
    metaDescription:
      '資生堂は、資生堂の独自の安全基準に準じ、合成香料の濃度を国際フレグランス協会および各国の法規制の中で最も低いレベルに制限して、アレルギーのリスクを最小限に抑えた上で、使用しています。',
  },
  {
    no: '21',
    path: 'impurities',
    name: '不純物',
    reading: 'フジュンブツ',
    subtitle:
      '重金属、アクリルアミド、ホルムアルデド、ジエタノールアミン、1,4-ジオキサン、アスベストなど',
    whatAreThey: '特定の成分に含まれる、非常に低いレベルの混入物質を指します。',
    whereFrom:
      '不純物は、成分の中に自然に含まれる、または特定の成分を作成する際の化学反応中に残留物として現れることがあります。',
    risks:
      '合成成分は精製されることで、比較的不純物を含まずに供給されますが、一部の不純物は化学反応の副産物（1,4-ジオキサン*1、ジエタノールアミン*2）や残留物（アクリルアミド*3）として、または他の化学物質と反応して生じる場合（ホルムアルデヒド*4）があります。\n天然由来の成分は、さまざまな種類の不純物（重金属*5、アスベスト*6）を有するため、供給源を選択し、不純物を継続的に監視することが重要です。\n\n*1;1,4-ジオキサン：発がん性物質と考えられています。\n*2;ジエタノールアミン：発がん性物質と考えられています。\n*3;アクリルアミド：発がん性物質と考えられています。\n*4;ホルムアルデヒド：発がん性物質と考えられており、肌アレルギー反応や発疹を引き起こす可能性もあります。\n*5;重金属：天然鉱物などに微量に含まれることがあり、種類によっては毒性を持つものがあります。\n*6;アスベスト：タルクに含まれる可能性がある発がん性物質と考えられています。',
    whyAndHow:
      '私たちは、不純物濃度をできるだけ低くして、安全性の懸念を最小化するために、原料の品質に関して厳選するプロセスを有しています。\n私たちの製品の安全性は、自社で厳しい管理基準を設定し不純物/微量成分を考慮して評価するとともに、評価すべき対象成分を日々アップデートし、管理システムをアップグレードしています。',
    related: ['6', '4', '16'],
    metaTitle: '不純物',
    metaKeywords:
      '不純物,重金属,アクリルアミド,ホルムアルデド,ジエタノールアミン,1.4-ジオキサン,アスベスト',
    metaDescription:
      '資生堂は、不純物濃度をできるだけ低くして、安全性の懸念を最小化するために、原料の品質に関して厳選するプロセスを有しています。化粧品の安全性は、自社で厳しい管理基準を設定し不純物/微量成分を考慮して評価するとともに、評価すべき対象成分を日々アップデートし、管理システムをアップグレードしています。',
  },
  {
    no: '19',
    path: 'coal-tar',
    name: 'コールタール',
    reading: 'コールタール',
    whatAreThey:
      'コールタールは、石炭に由来する粘性のある黒い液体です。フケ、脂漏性湿疹、乾癬の治療のためのスキンケアおよびヘアケア製品に使用されます。',
    whereFrom: '石炭の不完全燃焼で発生します。',
    risks:
      '肌への刺激や日光過敏、アレルギー反応を引き起こす可能性のある既知の発がん物質と考えられており、国際がん研究機関は、がんを引き起こすとされている発がん性物質（グループ1)に登録しています。',
    whyAndHow:
      '私たちは、資生堂独自の安全基準に準じ、コールタールは使用しません。',
    related: ['6', '4', '16'],
    metaTitle: 'コールタール',
    metaKeywords: 'コールタール',
    metaDescription:
      '資生堂は、独自の安全基準に準じ、コールタールは使用しません。',
  },
  {
    no: '20',
    path: 'phthalates',
    name: 'フタル酸エステル',
    reading: 'フタル酸エステル',
    whatAreThey:
      '様々なプラスチック製品に可塑剤として使用されている化学物質です。マニキュアのひび割れ防止、ヘアスプレーのつまり防止、香料の長時間持続剤としても使用されます。',
    whereFrom: '化学合成された成分です。',
    risks:
      'フタル酸エステルは、内分泌かく乱物資の懸念があり、欧州では化粧品への使用を禁止しています。',
    whyAndHow:
      '私たちは、資生堂独自の安全基準に準じ、フタル酸エステルは製品中には使用しません。\nさらにパッケージに関しては、フタル酸エステルが製品中に混入する可能性のある材料は使用していません。',
    related: ['6', '4', '16'],
    metaTitle: 'フタル酸エステル',
    metaKeywords: 'フタル酸エステル',
    metaDescription:
      '資生堂は、独自の安全基準に準じ、フタル酸エステルは化粧品中には使用しません。さらにパッケージに関しては、フタル酸エステルが化粧品中に混入する可能性のある材料は使用していません。',
  },
  {
    no: '22',
    path: 'octinoxate',
    name: 'オクチノキサート',
    reading: 'オクチノキサート',
    whatAreThey:
      '紫外線の有害な影響から肌を防御するために、日焼け止め化粧品で使用される合成化合物です。',
    whereFrom: '化学的に合成された成分です。',
    risks:
      'オクチノキサートは、WHOでは成長や免疫機能に影響を与える内分泌かく乱物質ではないと定義されています。しかし欧州では内分泌かく乱物質の懸念がある成分として安全性調査が継続されています。\nまた、海洋中でのサンゴへの影響について研究者の間で議論されており、21年時点ではハワイ州、パラオやタイ国立公園においては、レジャー用途での使用が禁止されています。',
    whyAndHow:
      '私たちは、資生堂独自の安全基準と、各国の法規制に準じ、オクチノキサートを使用しています。\nまた、造礁サンゴ類やサンゴ礁生物にまつわる研究テーマに取り組んでいる大学研究室との共同研究と高度な海洋中濃度シミュレーションを組み合わせる事でサンゴへの影響を精査に予測しています。海で使用するレジャー用サンスクリーンに使用する場合にはサンゴへの影響に配慮した処方設計を行っています。\nオクチノキサートについて、各国の規制動向や環境影響調査結果を注視して適切に対応していきます。',
    related: ['6', '4', '16'],
    metaTitle: 'オクチノキサート',
    metaKeywords: 'オクチノキサート',
    metaDescription:
      '資生堂は、独自の安全基準と、各国の法規制に準じるだけではなく、環境影響調査も行いながら、オクチノキサートを使用しています。',
  },
]
